<template>
  <div class="mt-8 flex flex-col gap-y-4">
    <h3 class="panel-header-title">
      % Cajas rechazadas por proveedor (Semanal)
    </h3>
    <div class="table-first-container">
      <div class="table-second-container">
        <div class="table-third-container">
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell">Proveedor</th>
                <th
                  v-for="(week, index) in weeks"
                  :key="index"
                  scope="col"
                  class="table-header-cell"
                >
                  Sem. {{ week }}
                </th>
                <th scope="col" class="table-header-cell">Total</th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                class="table-row"
                v-for="(item, index) in reorder_rejected_series"
                :key="index"
              >
                <td class="table-cell">
                  {{ item.name }}
                </td>
                <td
                  v-for="(_, index) in weeks"
                  :key="index"
                  class="table-cell-main"
                >
                  {{ item.data[index] }}
                </td>
                <td class="table-cell">
                  {{ item.data[item.data.length - 1] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <br />
    <h3 class="panel-header-title">
      Distribución del top 10 de defectos por proveedor
    </h3>
    <div class="table-first-container">
      <div class="table-second-container">
        <div class="table-third-container">
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell">Proveedor</th>
                <th
                  v-for="(provider, index) in providers.slice(1)"
                  :key="index"
                  scope="col"
                  class="table-header-cell"
                >
                  {{ provider }}
                </th>
                <th scope="col" class="table-header-cell">Total</th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                class="table-row"
                v-for="(item, index) in reorder_defect_series"
                :key="index"
              >
                <td class="table-cell">
                  {{ item.name }}
                </td>
                <td
                  v-for="(_, index) in providers.slice(1)"
                  :key="index"
                  class="table-cell-main"
                >
                  {{ item.data[index] }}
                </td>
                <td class="table-cell">
                  {{ item.data.reduce((acc, val) => acc + val, 0) }}
                </td>
              </tr>
              <tr class="table-row">
                <td class="table-cell">Total</td>
                <td
                  v-for="(_, index) in providers.slice(1)"
                  :key="index"
                  class="table-cell-main"
                >
                  {{
                    reorder_defect_series.reduce(
                      (acc, item) => acc + item.data[index],
                      0
                    )
                  }}
                </td>
                <td class="table-cell">
                  {{
                    reorder_defect_series.reduce(
                      (acc, item) =>
                        acc + item.data.reduce((acc, val) => acc + val, 0),
                      0
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QualityReportsContainerProviderShowProcessData",
  components: {},
  data() {
    return {};
  },
  props: {
    rejected_series: {
      type: Array,
      required: true,
    },
    defect_series: {
      type: Array,
      required: true,
    },
    providers: {
      type: Array,
      required: true,
    },
    weeks: {
      type: Array,
      required: true,
    },
  },
  created() {},
  computed: {
    reorder_rejected_series() {
      let new_rejected_series = [...this.rejected_series];
      let firstElement = new_rejected_series.shift();
      firstElement.name = "Total";
      new_rejected_series.push(firstElement);
      return new_rejected_series;
    },
    reorder_defect_series() {
      let new_defect_series = [...this.defect_series];

      return new_defect_series.map((item) => {
        return {
          name: item.name,
          data: item.data.slice(1),
        };
      });
    },
  },
};
</script>
